module.exports = __webpack_public_path__ + "static/media/ico_simulation_1_3_rule.4403b806.png";